<template>
  <div class="login-form">
    <b-alert v-if="formError" show variant="danger">
      <span class="text-sm">{{formError}}</span>
    </b-alert>
    <div class="form">
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <b-form @submit="onSubmit" @submit.stop.prevent>
          <div class="mb-3">
            <validation-provider rules="required" v-slot="{ errors }">
              <b-input-group id="input-group-user">
                <b-input-group-prepend is-text>
                  <b-icon icon="person-fill"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="input-user"
                              class="text-sm"
                              v-model="form.user"
                              type="text"
                              :placeholder="`${$t('auth.userName')} / ${$t('forms.emailAddress')}`"
                              required
                ></b-form-input>
              </b-input-group>
              <span class="form-error text-sm">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="password-container">
            <validation-provider rules="required|min:8" v-slot="{ errors }">
              <b-input-group id="input-group-password">
                <b-input-group-prepend is-text>
                  <b-icon icon="key"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="input-password"
                              class="text-sm"
                              v-model="form.password"
                              type="password"
                              :placeholder="$t('auth.password')"
                              required
                ></b-form-input>
              </b-input-group>
              <span class="form-error text-sm">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="button-container">
            <b-button type="submit"
                      :disabled="invalid || formSending"
                      variant="primary"
                      class="btn-rounded px-5 py-2 d-flex justify-content-center align-items-center">
              <span class="text-md text-uppercase">{{$t('auth.login')}}</span>
              <b-spinner v-if="formSending" type="grow" small class="ml-3"></b-spinner>
            </b-button>
          </div>
        </b-form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';
import { i18n } from 'vue-lang-router';

extend('required', {
  ...required,
  message: i18n.t('forms.thisFieldIsRequired'),
});
extend('email', {
  ...email,
  message: i18n.t('forms.emailNotValid'),
});
extend('min', {
  ...min,
  message: i18n.t('forms.atLeastCharacters'),
});

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    goBackAfterLogin: Boolean,
    isNavigationForm: Boolean,
  },
  data() {
    return {
      form: {
        user: '',
        password: '',
      },
      formSending: false,
      formError: '',
    };
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate().then(() => {
        const data = {
          password: this.form.password,
        };
        // eslint-disable-next-line
        data[this.isEmailValid(this.form.user) ? 'email' : 'username'] = this.form.user;
        this.formError = '';
        this.formSending = true;
        this.$store.dispatch('user/LOGIN', data).then(() => {
          this.formSending = false;
          if (!this.isNavigationForm) {
            if (this.goBackAfterLogin && !this.isNavigationForm) {
              this.$router.go(-1);
            } else {
              this.$router.push(`/${this.$i18n.locale}/`);
            }
          }
        }).catch((error) => {
          this.formSending = false;
          this.formError = error;
        });
      });
    },
  },
};
</script>
